
<style lang="sass">
    .brand-question-answer{
        width:100%;
        .brand-padding-15px {
            box-sizing:border-box;
            padding-left:15px;
            padding-right:15px;
        }
        .qa-list {
            &:last-child:after {
                border:none;
            }
            >div {
                display: inherit;
                padding-top: 15px;
                padding-bottom: 15px;
            }
            .list-question {
                width:100%;
                font-size: 16px;
                color: #222222;
                line-height: 20px;
                text-align: left;
                display:flex;
                .list-question-content {
                    display:block;
                    flex:1;
                }
                .triangle {
                    width:20px;
                    display:block;
                    position:relative;
                }
                .triangle:after {
                    position: absolute;
                    right: 0;
                    top: 35%;
                    content: " ";
                    display: inline-block;
                    -webkit-transform: rotate(135deg);
                    transform: rotate(135deg);
                    height: 6px;
                    width: 6px;
                    border-width: 2px 2px 0 0;
                    border-color: #C8C8CD;
                    border-style: solid;
                }
            }
            .list-answer {
                background-color: #fafafa;
                font-size: 14px;
                display:flex;
                .list-answer-a {
                    background: #00a1f4;
                    width: 18px;
                    height: 18px;
                    line-height:18px;
                    border-radius: 100%;
                    font-size: 12px;
                    color: #FFFFFF;
                    text-align: center;
                    display: inline-block;
                }
                .list-answer-content {
                    flex:1;
                    padding-left: 10px;
                    font-size: 14px;
                    color: #666666;
                    line-height: 22px;
                }
            }
        }
    }
</style>

<template>
    <div class="brand-question-answer">
        <ul>
            <li v-for="(data,index) in datas" @click="showAnswer(index)" :key="index" class="qa-list wui-border-1px wui-border-b">
                <div class="list-question brand-padding-15px">
                    <span class="list-question-content">{{data.question}}</span>
                    <span class="triangle"></span>
                </div>
                <div v-show="currentIndex === index" class="list-answer brand-padding-15px">
                    <span class="list-answer-a">答</span>
                    <div id="" class="list-answer-content">
                        <p v-for="answer in data.answer">{{answer.answerQues || '&nbsp;'}}</p>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        datas: Array
    },
    data() {
        return {
            list: [],
            currentIndex: ''
        }
    },
    methods: {
        showAnswer(index) {
            var target = this.list[index];
            if (this.currentIndex === index){
                this.currentIndex = ''
            }else{
                this.currentIndex = index;
                target = this.list[this.currentIndex]
            }
            
            if(target){
                this.$nextTick(()=>{
                    target.querySelector('.list-answer').scrollIntoView()
                })
            }
        },
        openAnswer() {

        }
    },
    mounted() {
        this.$nextTick(()=>{
            this.list = this.$el.querySelectorAll('li');
        })
    }
}
</script>



// WEBPACK FOOTER //
// question-answer.vue?bb33d670